import { Controller } from "@hotwired/stimulus"
// The offer page's photo index: a tile opens its picture full-screen in the
// native <dialog>; arrows (and ← →) step through the same photos, wrapping at
// the ends; a tap on the backdrop, Escape or Close shuts it. The list of
// full-size URLs is data-lightbox-urls-value, in the tiles' order.
export default class extends Controller {
  static targets = ["dialog", "image", "counter"]
  static values = { urls: Array, index: { type: Number, default: 0 } }

  open(event) {
    this.indexValue = Number(event.currentTarget.dataset.lightboxIndex) || 0
    this.paint()
    this.dialogTarget.showModal()
  }

  close() { this.dialogTarget.close() }
  prev(event) { event?.stopPropagation(); this.go(this.indexValue - 1) }
  next(event) { event?.stopPropagation(); this.go(this.indexValue + 1) }

  // The dialog itself is the backdrop: a click on the picture or the arrows
  // stops before reaching it.
  backdrop(event) { if (event.target === this.dialogTarget) this.close() }

  keydown(event) {
    if (event.key === "ArrowLeft") this.prev()
    if (event.key === "ArrowRight") this.next()
  }

  go(i) {
    const n = this.urlsValue.length
    if (n === 0) return
    this.indexValue = ((i % n) + n) % n
    this.paint()
  }

  paint() {
    this.imageTarget.src = this.urlsValue[this.indexValue]
    if (this.hasCounterTarget) this.counterTarget.textContent = `${this.indexValue + 1} / ${this.urlsValue.length}`
  }
}
